import { render, staticRenderFns } from "./AlertasSnack.vue?vue&type=template&id=e20f5cf6&scoped=true&"
import script from "./AlertasSnack.vue?vue&type=script&lang=js&"
export * from "./AlertasSnack.vue?vue&type=script&lang=js&"
import style0 from "./AlertasSnack.vue?vue&type=style&index=0&id=e20f5cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20f5cf6",
  null
  
)

export default component.exports